import { defineMessages } from '@jutro/locale';

export default defineMessages({
    addX: {
        id: 'ml.gateway.MLVehicleOperatorListPopup.Add driverType',
        defaultMessage: 'Add {driverType}'
    }
    
});
